<template>
  <div
    data-pendo-ds="hidden_input"
  >
    <input
      :data-testid="`${id}_hidden_input`"
      :disabled="disabled"
      type="hidden"
      :value="value"
    >
  </div>
</template>

<script>
export default {
  name: 'HiddenInput',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
  },
}
</script>
